import { store } from "../redux/store";
import { IAlertState, addAlert } from "../redux/slices/appSlice";
import { AlertSeverity } from "../../models/common/enums";
import { t } from "i18next";
import { GeolocationPosition } from "../../models/workShiftTimeSlot/workTimeStartFormItem";

const getCurrentPosition = async(): Promise<GeolocationPosition> => {
    return await new Promise<GeolocationPosition>((resolve, reject) => {
        try {
            if (!("geolocation" in navigator)) {
                const errorMessage = "geolocation DOES NOT exist in navigator";
                console.log(errorMessage);
                return reject(new Error(errorMessage));
            }
            navigator.geolocation.getCurrentPosition(
                (result) => {
                    // Success
                    return resolve({
                        latitude: result.coords.latitude,
                        longitude: result.coords.longitude,
                    });
                },
                (error: GeolocationPositionError) => {
                    const errorMessage =
                        "geolocation.getCurrentPosition FAILED";
                    console.log(errorMessage, error);
                    return reject(error);
                },
                { enableHighAccuracy: true, timeout: 60000, maximumAge: 0 }
            );
        } catch (e) {
            console.log("getGeolocationPosition FAILED", e);
            return reject(e);
        }
    });
};

export const getGeolocationPosition = async(
    alert: IAlertState = {
        message: t("validation.geolocationPositionError"),
        severity: AlertSeverity.Error,
    }
): Promise<GeolocationPosition> => {
    try {
        return await getCurrentPosition();
    } catch {
        store.dispatch(addAlert(alert));
        return null;
    }
};
